import { createReducer, on } from '@ngrx/store';
import * as fromLocationsActions from '../../actions/locations/locations.actions';

export const locationsFeatureKey = 'locations';

export interface State {
  locations: any;
  selectedLocationsFilter: string;
}

export const initialState: State = {
  locations: [],
  selectedLocationsFilter: 'showAll'
};

export const reducer = createReducer(
  initialState,
  on(fromLocationsActions.loadLocationsSuccess, (state, action) => {
    return {
      ...state,
      locations: action.locations
    };
  }),
  on(
    fromLocationsActions.selectLocationsFilter,
    (state, action) => {
      return {
        ...state,
        selectedLocationsFilter: action.selectedLocationsFilter
      };
    }
  ),
);
